// import store from './store';

export const getUserInfo = state => {
  return Object.assign({
    userid: null,
    session: null,
    username: null,
    avatar: null,
    authority: null,
    balance: null,
  }, state.user);
};

export const isLogin = state => {
  return !!state.user.userid;
};

export const getMessage = state => {
  return state.message.message;
};

export const getContact = state => {
  return state.message.contact;
};

export const getSchoolId = state => {
  return state.school.schoolId;
};

export const getSchool = state => {
  return state.school.school;
};

export const getSchoolList = state => {
  return state.school.schoolList;
};

export const getStyleIsWide = state => {
  return state.style.wide;
};

export const getTypes = state => {
  return state.types.types;
};



// WEBPACK FOOTER //
// ./src/vuex/getters.js